export enum Message {
  'newTab' = 'newTab',
  'sameTab' = 'sameTab',
  'newActiveTab' = 'newActiveTab',
  'passVersionFromContentToWeb' = 'passVersionFromContentToWeb',
}
